var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentBankIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M9.6 1.37a2 2 0 0 1 2.8 0l1.267 1.242a2 2 0 0 0 1.379.571l1.773.018a2 2 0 0 1 1.98 1.98l.018 1.774a2 2 0 0 0 .571 1.378l1.241 1.268a2 2 0 0 1 0 2.798l-1.241 1.268a2 2 0 0 0-.571 1.379l-.018 1.773a2 2 0 0 1-1.98 1.98l-1.773.018a2 2 0 0 0-1.38.571L12.4 20.629a2 2 0 0 1-2.798 0l-1.268-1.241a2 2 0 0 0-1.378-.571l-1.774-.018a2 2 0 0 1-1.98-1.98l-.018-1.773a2 2 0 0 0-.571-1.38L1.371 12.4a2 2 0 0 1 0-2.798l1.241-1.268a2 2 0 0 0 .571-1.378l.018-1.774a2 2 0 0 1 1.98-1.98l1.774-.018a2 2 0 0 0 1.378-.571l1.268-1.241Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.64 8.527a.679.679 0 0 0-.974.946L9.226 11l-1.56 1.527a.667.667 0 0 0 .217 1.092.666.666 0 0 0 .73-.146l2-2a.665.665 0 0 0 0-.946l-1.973-2Zm5.666 2-2-2a.67.67 0 1 0-.946.946L12.893 11l-1.533 1.527a.667.667 0 0 0 .217 1.092.666.666 0 0 0 .73-.146l2-2a.667.667 0 0 0 .026-.946h-.027Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentBankIco);
export default __webpack_public_path__ + "static/media/sentBankIco.486fbe397557f7dd5b2024be07252458.svg";
export { ForwardRef as ReactComponent };